import { useContext } from "react";
import { LocationContext } from "../contexts/LocationContext";

const useLocationContext = () => useContext(LocationContext);

export default useLocationContext;
